import Header from '@di-shared/features/common/Header';
import HeaderBackButton from '@di-shared/features/common/HeaderBackButton';
import ScrollToTopOnMount from '@di-shared/features/common/ScrollToTopOnMount';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import SafeDrivingReport from '@di-shared/features/safe-driving-LN/report/SafeDrivingReport';

export interface SafeDrivingReportPageProps {
  vin: string;
}

function SafeDrivingReportPage({vin}: SafeDrivingReportPageProps) {
  const {t} = useInferableTranslation();

  return (
    <div className="wrap">
      <ScrollToTopOnMount />
      <Header left={<HeaderBackButton />}>
        <h1 className="headline_xxsmall nav_center_title">{t('ctn_dss_LN_driving_safety_report')}</h1>
      </Header>
      <SafeDrivingReport vin={vin} />
    </div>
  );
}

export default SafeDrivingReportPage;
